import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api from '../utils/api';

export default function ResetPassword() {
  const [params]                  = useSearchParams();
  const navigate                  = useNavigate();
  const token                     = params.get('token');
  const [password, setPassword]   = useState('');
  const [confirm, setConfirm]     = useState('');
  const [loading, setLoading]     = useState(false);
  const [done, setDone]           = useState(false);
  const [error, setError]         = useState('');

  useEffect(() => {
    if (!token) setError('Invalid or missing reset link. Please request a new one.');
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) { setError('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { setError('Passwords do not match.'); return; }
    setLoading(true);
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setDone(true);
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. The link may have expired — please request a new one.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', padding:16 }}>
      <div style={{ width:'100%', maxWidth:400 }}>

        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:32 }}>
          <div style={{ fontSize:'1.8rem', fontWeight:700, color:'#403EC9', letterSpacing:'-1px' }}>
            alveofit<span style={{ color:'#A5B4FC' }}>°</span>
          </div>
          <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', marginTop:2 }}>Sales Intelligence Platform</div>
        </div>

        <div className="card" style={{ padding:'32px 28px' }}>
          {done ? (
            <div style={{ textAlign:'center', padding:'8px 0' }}>
              <div style={{ fontSize:48, marginBottom:16 }}>✅</div>
              <h2 style={{ margin:'0 0 8px', fontSize:'1.2rem', fontWeight:700 }}>Password reset!</h2>
              <p style={{ margin:'0 0 24px', fontSize:'0.875rem', color:'var(--text-secondary)', lineHeight:1.6 }}>
                Your password has been updated. Redirecting you to login…
              </p>
              <Link to="/login" className="btn btn-primary" style={{ display:'block', textAlign:'center' }}>
                Go to login
              </Link>
            </div>
          ) : (
            <>
              <h2 style={{ margin:'0 0 6px', fontSize:'1.2rem', fontWeight:700 }}>Set a new password</h2>
              <p style={{ margin:'0 0 24px', fontSize:'0.875rem', color:'var(--text-secondary)' }}>
                Choose a strong password for your Alveofit account.
              </p>

              {error && (
                <div style={{ background:'var(--danger-bg)', color:'var(--danger)', borderRadius:'var(--radius-md)', padding:'10px 14px', marginBottom:16, fontSize:'0.875rem', lineHeight:1.5 }}>
                  {error}
                  {error.includes('expired') && (
                    <div style={{ marginTop:8 }}>
                      <Link to="/forgot-password" style={{ color:'var(--danger)', fontWeight:600 }}>
                        Request a new link →
                      </Link>
                    </div>
                  )}
                </div>
              )}

              {token && !error.includes('missing') && (
                <form onSubmit={submit}>
                  <div className="form-group">
                    <label className="form-label">New password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={password}
                      onChange={e => setPassword(e.target.value)}
                      placeholder="Min 8 characters"
                      required
                      autoFocus
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">Confirm password</label>
                    <input
                      className="form-control"
                      type="password"
                      value={confirm}
                      onChange={e => setConfirm(e.target.value)}
                      placeholder="Repeat password"
                      required
                    />
                  </div>

                  {/* Password strength indicator */}
                  {password.length > 0 && (
                    <div style={{ marginBottom:16 }}>
                      <div style={{ height:4, borderRadius:2, background:'var(--border)', overflow:'hidden' }}>
                        <div style={{
                          height:'100%', borderRadius:2, transition:'width 0.3s',
                          width: password.length < 8 ? '25%' : password.length < 12 ? '60%' : '100%',
                          background: password.length < 8 ? '#DC2626' : password.length < 12 ? '#D97706' : '#16A34A',
                        }} />
                      </div>
                      <div style={{ fontSize:'0.72rem', color:'var(--text-muted)', marginTop:4 }}>
                        {password.length < 8 ? 'Too short' : password.length < 12 ? 'Good' : 'Strong'}
                      </div>
                    </div>
                  )}

                  <button
                    type="submit"
                    className="btn btn-primary"
                    style={{ width:'100%' }}
                    disabled={loading || !token}
                  >
                    {loading ? 'Resetting…' : 'Reset password'}
                  </button>
                </form>
              )}
            </>
          )}
        </div>

        <div style={{ textAlign:'center', marginTop:20 }}>
          <Link to="/login" style={{ fontSize:'0.875rem', color:'var(--text-secondary)', textDecoration:'none' }}>
            ← Back to login
          </Link>
        </div>
      </div>
    </div>
  );
}
